import selectIdTypeValidation from "./selectIdTypeValidation";
import identificationValidation from "components/PLCTABS/CompanyOfficialsTab/AssembledCompanyOfficialForms/commonValidationSchema/identificationValidation";
import residentialDetailsValidation from "components/PLCTABS/CompanyOfficialsTab/AssembledCompanyOfficialForms/commonValidationSchema/residentialDetailsValidation";
import uploadDocumentsValidation from "components/PLCTABS/CompanyOfficialsTab/AssembledCompanyOfficialForms/commonValidationSchema/uploadDocumentsValidation";
import beneficialOwnershipFormValidation from "./beneficialOwnershipFormValidation";

/**
 * This returns an object composed of conditional `yup` schema,
 * based on the current tab of `Shareholder` and `Director Shareholder` officials.
 *
 * @param {string} selectedTab The current tab/step of the multi step form e.g `"generalInformation"`.
 * @param {string} idType The idType of the current official e.g `"Kenyan Citizen"`.
 * @param {string} isNonResident Conditional string value `'No' || 'Yes` of the current official.
 * @param {array} documentData The array of objects related to file uploads.
 * @param {object} beneficialOwnershipForm Beneficial ownership form object.
 * @param {number} selectedShareholder Max percentage of shareholding.
 * @param {Boolean} renderLongForm Render long form `true` | `false`.
 * @return {object} This returns object containing schema.
 * @example
 *  {
 *    schema // yup schema
 *  }
 */
const getValidationSchema = ({
  selectedTab,
  idType,
  isNonResident = null,
  documentData,
  beneficialOwnershipForm,
  selectedShareholder,
  renderLongForm,
}) => {
  if (!selectedTab?.id && renderLongForm)
    return selectIdTypeValidation()
      .schema.concat(
        beneficialOwnershipFormValidation(
          idType,
          beneficialOwnershipForm,
          selectedShareholder,
          renderLongForm
        ).schema
      )
      .concat(identificationValidation(idType).schema)
      .concat(residentialDetailsValidation({ idType, isNonResident }).schema)
      .concat(uploadDocumentsValidation(documentData).schema);

  if (!selectedTab?.id && !renderLongForm)
    return selectIdTypeValidation()
      .schema.concat(
        beneficialOwnershipFormValidation(
          idType,
          beneficialOwnershipForm,
          selectedShareholder,
          renderLongForm
        ).schema
      )
      .concat(identificationValidation(idType).schema);

  switch (selectedTab.id) {
    case "assignOfficials":
      return selectIdTypeValidation();
    case "beneficialOwnershipAllocation":
      return beneficialOwnershipFormValidation(
        idType,
        beneficialOwnershipForm,
        selectedShareholder,
        renderLongForm
      );
    case "generalInformation":
      return identificationValidation(idType);
    case "residentialDetails":
      return residentialDetailsValidation({ idType, isNonResident });
    case "uploadDocuments":
      return uploadDocumentsValidation(documentData);
    default:
      return { schema: null };
  }
};

export default getValidationSchema;
